export * as iconStyleConfigs from './style-configs';
export { Icon } from './icon';
export type { IconProps, IconStyleConfig } from './types';
